import React from "react";
import { Container } from "../ui";
import "./LocalAlert.style.scss";

export const LocalAlert: React.FunctionComponent<{}> = ({ children }) => {
    return (
        <Container className="component-local-alerts" block={false}>
            <div className="component-local-alert">{children}</div>
        </Container>
    );
};

export default LocalAlert;
